export default __webpack_public_path__ + "static/media/NCDC_logo.922eaf14.png";